import {Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash';
import {NzSafeAny} from "ng-zorro-antd/core/types";
import {Utils} from '@core/utils/utils';

@Pipe({
  name: 'tableFiledPipe',
})
export class TableFiledPipe implements PipeTransform {
  constructor() {
  }

  transform(value: NzSafeAny, args?: string): NzSafeAny {
    let line = _.get(value, args!, "-");
    return Utils.isUnKnownValue(line) ? '-' : line;
  }
}
